import React from "react";

import Joi from "joi-browser";
import Form from "../common/Form";

import db from "../../services/query";
import lbl from "../../data/Labels.json";

import { PopUpContext } from "../../contexts/popUpContext";

class ExpensePopUp extends Form {
  static contextType = PopUpContext;

  state = {
    drp: {
      accounts: [],
      employees: [],
      contractors: [],
    },
    data: {
      amount: "",
      account_id: "",
      payment_date: "",
      paid_by_staff_id: "",
      paid_to_contractor_id: "",
      remark: "",
      attachment: "",
      bank_ref_no: "",
    },
    errors: {},
  };

  componentDidMount = async () => {
    const { drp, data } = this.state;
    const {
      popUp: { edit },
    } = this.context;

    if (edit) {
      data.amount = edit.amount;
      data.account_id = edit.account_id;
      data.payment_date = edit.payment_date;
      data.paid_by_staff_id = edit.paid_by_staff_id;
      data.paid_to_contractor_id = edit.paid_to_contractor_id;
      data.remark = edit.remark;
      data.bank_ref_no = edit.bank_ref_no;
    }

    await db
      .getAll(`dropdowns/staff?sectionId=1`)
      .then(({ data: { data } }) => (drp["employees"] = data));

    await db
      .getAll(`dropdowns/accounts`)
      .then(({ data: { data } }) => (drp["accounts"] = data));

    await db
      .getAll(`dropdowns/contractors`)
      .then(({ data: { data } }) => (drp["contractors"] = data));

    this.setState({ drp, data });
  };

  schema = {
    amount: Joi.number().required(),
    account_id: Joi.number().required(),
    payment_date: Joi.string().required(),
    paid_by_staff_id: Joi.number().required(),
    paid_to_contractor_id: Joi.number().required(),
    remark: Joi.string().max(1024),
    attachment: Joi.allow(null).allow(""),
    bank_ref_no: Joi.string().required(),
  };

  doSubmit = async ({ target }) => {
    try {
      const { togglePopUp, popUp } = this.context;

      const __controls = this.cleanObject({
        expense_sub_account_id: popUp?.sid,
        ...this.state.data,
      });

      await db
        .form("expenses", target, __controls, popUp?.edit?.id)
        .then(() => {
          togglePopUp({ form: "toast" });
        })

        .catch((err) => {
          togglePopUp({
            form: "toast",
            message: err.toString(),
            type: "warning",
          });
        });
    } catch ({ response }) {
      if (response && response.status === 400) {
        const errors = { ...this.state.error };

        this.setState({ errors });
      }
    }
  };

  render() {
    const { drp } = this.state;
    const { popUp } = this.context;

    return (
      <div className="form-container">
        <form className="form crud" onSubmit={this.handleSubmit}>
          <div className="head">
            <p>{popUp?.edit ? lbl.EditExpense : lbl.AddExpense}</p>
          </div>
          <div className="form-inputs">
            {this.renderInput("amount", "مبلغ", "number")}
            {this.renderSelect("account_id", "حساب", drp["accounts"])}
            {this.renderSelect(
              "paid_by_staff_id",
              "پرداخت کننده",
              drp["employees"]
            )}
            {this.renderSelect(
              "paid_to_contractor_id",
              "طرف قرارداد",
              drp["contractors"]
            )}
            {this.renderInput("payment_date", "تاریخ پرداخت", "date")}
            {this.renderInput("bank_ref_no", "ریفرنس نمبر")}
            {this.renderInput("remark", "ملاحظه", "textarea")}
            {this.renderFile("attachment", "سند")}
          </div>
          <div className="form-buttons">
            {this.renderButton(popUp?.edit ? lbl.Edit : lbl.Save)}
          </div>
        </form>
      </div>
    );
  }
}

export default ExpensePopUp;
